import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class Dashlib2Service {

  constructor() { }
}
